export var Key;
(function (Key) {
    Key.KeyA = "KeyA";
    Key.KeyB = "KeyB";
    Key.KeyC = "KeyC";
    Key.KeyD = "KeyD";
    Key.KeyE = "KeyE";
    Key.KeyF = "KeyF";
    Key.KeyG = "KeyG";
    Key.KeyH = "KeyH";
    Key.KeyI = "KeyI";
    Key.KeyJ = "KeyJ";
    Key.KeyK = "KeyK";
    Key.KeyL = "KeyL";
    Key.KeyM = "KeyM";
    Key.KeyN = "KeyN";
    Key.KeyO = "KeyO";
    Key.KeyP = "KeyP";
    Key.KeyQ = "KeyQ";
    Key.KeyR = "KeyR";
    Key.KeyS = "KeyS";
    Key.KeyT = "KeyT";
    Key.KeyU = "KeyU";
    Key.KeyV = "KeyV";
    Key.KeyW = "KeyW";
    Key.KeyX = "KeyX";
    Key.KeyY = "KeyY";
    Key.KeyZ = "KeyZ";
    Key.Digit0 = "Digit0";
    Key.Digit1 = "Digit1";
    Key.Digit2 = "Digit2";
    Key.Digit3 = "Digit3";
    Key.Digit4 = "Digit4";
    Key.Digit5 = "Digit5";
    Key.Digit6 = "Digit6";
    Key.Digit7 = "Digit7";
    Key.Digit8 = "Digit8";
    Key.Digit9 = "Digit9";
    Key.F1 = "F1";
    Key.F2 = "F2";
    Key.F3 = "F3";
    Key.F4 = "F4";
    Key.F5 = "F5";
    Key.F6 = "F6";
    Key.F7 = "F7";
    Key.F8 = "F8";
    Key.F9 = "F9";
    Key.F10 = "F10";
    Key.F11 = "F11";
    Key.F12 = "F12";
    Key.ArrowUp = "ArrowUp";
    Key.ArrowDown = "ArrowDown";
    Key.ArrowLeft = "ArrowLeft";
    Key.ArrowRight = "ArrowRight";
    Key.Enter = "Enter";
    Key.Space = "Space";
    Key.Tab = "Tab";
    Key.Escape = "Escape";
    Key.Backspace = "Backspace";
    Key.Delete = "Delete";
    Key.DeleteAction = "DeleteAction";
    Key.Insert = "Insert";
    Key.Home = "Home";
    Key.End = "End";
    Key.PageUp = "PageUp";
    Key.PageDown = "PageDown";
    Key.ShiftLeft = "ShiftLeft";
    Key.ShiftRight = "ShiftRight";
    Key.ControlLeft = "ControlLeft";
    Key.ControlRight = "ControlRight";
    Key.AltLeft = "AltLeft";
    Key.AltRight = "AltRight";
    Key.MetaLeft = "MetaLeft";
    Key.MetaRight = "MetaRight";
    Key.Minus = "Minus";
    Key.Equal = "Equal";
    Key.BracketLeft = "BracketLeft";
    Key.BracketRight = "BracketRight";
    Key.Backslash = "Backslash";
    Key.Semicolon = "Semicolon";
    Key.Quote = "Quote";
    Key.Backquote = "Backquote";
    Key.Comma = "Comma";
    Key.Period = "Period";
    Key.Slash = "Slash";
    Key.Numpad0 = "Numpad0";
    Key.Numpad1 = "Numpad1";
    Key.Numpad2 = "Numpad2";
    Key.Numpad3 = "Numpad3";
    Key.Numpad4 = "Numpad4";
    Key.Numpad5 = "Numpad5";
    Key.Numpad6 = "Numpad6";
    Key.Numpad7 = "Numpad7";
    Key.Numpad8 = "Numpad8";
    Key.Numpad9 = "Numpad9";
    Key.NumpadAdd = "NumpadAdd";
    Key.NumpadSubtract = "NumpadSubtract";
    Key.NumpadMultiply = "NumpadMultiply";
    Key.NumpadDivide = "NumpadDivide";
    Key.NumpadDecimal = "NumpadDecimal";
    Key.NumpadEnter = "NumpadEnter";
})(Key || (Key = {}));
